<template>
  <div>
    <div class="admin-upload">
      <div class="avatar">
        <img :src="detailCompany.logo" alt class="avt-modal" />
      </div>
    </div>
    <div class="vendor__title">{{truncate(detailCompany.company_name,10,'...')}}</div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'SidebarVendor',
  computed: {
    ...mapState({
      detailCompany: state => state.adminCompany.detailCompany
    })
  },
  mounted () {
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/stylesheet/admin/vendor.scss';
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Sidebar.vue